import { Avatar } from "primereact/avatar";
import { Card } from "primereact/card";

const header = () => {
    return <div style={{padding: '1rem 1rem'}} className="flex-score align-items-center">
    <Avatar className="nadaConstaAvatar" style={{backgroundColor: "rgba(101, 214, 173, 0.1)"}} icon="pi pi-verified" size="xlarge" shape="circle" />
    <span className="nadaConstaText" style={{paddingLeft: "1rem"}}><b>Nada Consta</b></span>
</div> 
}

const NadaConsta = () => {
    return (
        <>
            <Card header={header} style={{height:'3.8rem', backgroundColor: "rgba(101, 214, 173, 0.1)", color: "rgb(39, 171, 131)", border: "1px solid rgb(101, 214, 173)"}}>
                
            </Card>
        </>
    )
  }
export default NadaConsta;